import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Navigate } from "react-router-dom";
import { sessionService } from "redux-react-session";
import { handleCallback } from "../../utils/user-manager";

import { initializeApp, syncReportUser } from "../../auth/actions/userActions";
import { END_GET_USER_REPORT_DATA, ERROR_GET_USER_REPORT_DATA } from "../../hooks/report";
import LoadingScreen from "../../components/LoadingScreen";

const Callback = () => {
    const authenticated = useSelector((state) => state.session.authenticated);
    const company = useSelector((state) => state.user.company);
    const dispatch = useDispatch();

    useEffect(() => {
        const handleAuth = async () => {
            if (authenticated) return;

            try {
                // If your handleCallback reads URL hash/query and exchanges tokens, it’s async.
                const response = await handleCallback();
                const { access_token, profile } = response;

                await sessionService.saveSession(access_token);
                await sessionService.saveUser(profile);

                // Initialize your app state with the user id/sub
                dispatch(initializeApp(profile.sub));

                // If syncReportUser returns a promise (API call), await it
                const responseReport = await syncReportUser(profile.sub);
                const { data: dataReport, status: statusReport } = responseReport;

                if (statusReport === 201) {
                    if (dataReport?.user) {
                        dispatch({ type: END_GET_USER_REPORT_DATA, payload: dataReport.user });
                        localStorage.setItem("user-report", JSON.stringify(dataReport.user));
                    }
                } else {
                    throw new Error(
                        typeof dataReport === "string" ? dataReport : JSON.stringify(dataReport)
                    );
                }
            } catch (error) {
                dispatch({ type: ERROR_GET_USER_REPORT_DATA, payload: error?.message || String(error) });
            }
        };

        handleAuth();
    }, [authenticated, dispatch]);

    // Só navega depois que empresa/permissões carregaram: o AuthRoute de "/"
    // usa esses dados para escolher a primeira rota que o usuário pode ver.
    if (authenticated && company) {
        return <Navigate to="/" replace />;
    }

    // Tela de marca enquanto trocamos o token e carregamos as permissões
    return <LoadingScreen message="Entrando no sistema…" />;
};

export default Callback;
